import React from 'react';

const RedditLogo = ({
  width = 50,
  height = 50,
  color = '#066653',
  ...props
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 50 50'
    fill={color}
    aria-label='Reddit logo'
    {...props}>
    <path d='M29 3c-2.1 0-4.57 1.65-4.94 9.03.313-.8.62-.31.94-.31.35 0 .715.02 1.06.031C26.3 7.6 27.36 5 29 5c.703 0 1.1.383 1.84 1.19.867.94 2 2.16 4.22 2.62-.036-.262-.063-.543-.063-.813 0-.422.04-.82.12-1.22-1.38-.375-2.1-1.17-2.81-1.937C31.52 3.98 30.61 3 29 3zm12 1c-2.21 0-4 1.8-4 4s1.793 4 4 4 4-1.8 4-4-1.79-4-4-4zM25 14C12.867 14 3 20.18 3 29s9.867 16 22 16 22-7.18 22-16-9.87-15-22-15zm-17.5.938c-1.46 0-2.85.597-3.91 1.66-1.72 1.72-2.08 4.2-1.09 6.25 1.51-2.93 4.11-5.42 7.47-7.28-.762-.387-1.61-.625-2.47-.625zm35 0c-.863 0-1.71.238-2.47.625 3.36 1.86 5.96 4.36 7.47 7.28.984-2.05.629-4.53-1.09-6.25-1.06-1.06-2.44-1.66-3.91-1.656zM17 23c1.656 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm16 0c1.656 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm-16.94 11c.25.04.497.18.657.41.105.15 2.45 3.28 8.28 3.28 5.91 0 8.26-3.22 8.28-3.25.32-.45.95-.57 1.41-.25.45.32.535.92.219 1.38-.117.17-2.97 4.12-9.91 4.12-6.94 0-9.79-3.96-9.91-4.12-.316-.453-.234-1.06.219-1.38.226-.16.5-.23.75-.188z' />
  </svg>
);

export default RedditLogo;
